/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-closing-bracket-location */
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Fab from '@material-ui/core/Fab';
import { withTranslation } from 'react-i18next';

import Loader from '../Common/Loader';
import { commonStyleForEditPersonalInfo } from '../Common/CommonStyle';
import { hot } from 'react-hot-loader';

class BaseRatingForm extends React.Component {
	render() {
		const { classes } = this.props;
		return (
			<section style={{ background: '#fff', display: 'flex', justifyContent: 'center' }}>
				<Grid id="edit_rating_grid" sm={8} xs={12} container>
					<Grid className={classes.root} item sm={12} xs={12}>
						<Paper className={classes.paper}>
							<Card className={classes.root} variant="outlined">
								<Grid className={classes.root} container alignItems="center">
									<Grid sm={12} xs={12}>
										<Grid
											alignItems="center"
											className={classes.root}
											container
											justify="center"
											spacing={2}>
											{this.props.children}
										</Grid>
									</Grid>
								</Grid>
							</Card>
						</Paper>
					</Grid>
				</Grid>
				{this.props.isLoading ? <Loader /> : ''}
			</section>
		);
	}
}

export default hot(module)(withStyles(commonStyleForEditPersonalInfo)(withTranslation()(BaseRatingForm)));
